import type { LifecycleDiagnosticsItem } from '../../types/lifecycle';

interface Props {
  items: LifecycleDiagnosticsItem[];
  available: boolean;
}

export function DiagnosticsPanel({ items, available }: Props) {
  if (!available) {
    return (
      <details className="diagnostics-panel">
        <summary>Diagnostika (pro správce)</summary>
        <p className="diagnostics-panel__empty">Diagnostická data nejsou k dispozici.</p>
      </details>
    );
  }
  return (
    <details className="diagnostics-panel">
      <summary>Diagnostika (pro správce)</summary>
      <p className="diagnostics-panel__intro">
        Tisky bez analýzy, placeholder výstupy a chyby PDF extrakce.
        Sbaleno default. Pro běžné čtení nemá smysl — slouží správci a žurnalistům
        pro kontrolu, že systém funguje.
      </p>
      {items.length === 0 ? (
        <p className="diagnostics-panel__empty">Žádné diagnostické položky.</p>
      ) : (
        <table className="diagnostics-panel__table">
          <thead>
            <tr><th>Tisk</th><th>Stav</th><th>Chyba</th></tr>
          </thead>
          <tbody>
            {items.map((d) => (
              <tr key={d.key}>
                <td>{d.proposal_id ?? '—'} — {d.title}</td>
                <td><span className={`badge badge--${d.presentation_state}`}>{d.presentation_state}</span></td>
                <td className="muted">{d.last_error ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </details>
  );
}
